import { render, staticRenderFns } from "./VPasswordField.vue?vue&type=template&id=3c5c94dd&scoped=true"
import script from "./VPasswordField.vue?vue&type=script&lang=js"
export * from "./VPasswordField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5c94dd",
  null
  
)

export default component.exports